import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { cn } from "../../lib/utils";

const BASE =
  "flex h-11 w-full rounded-xl border border-input bg-white px-4 text-sm outline-none transition-colors placeholder:text-muted-foreground focus:border-primary focus:ring-2 focus:ring-primary/20";

export default function Input({ className, type, ...props }) {
  const [visible, setVisible] = useState(false);

  if (type !== "password") {
    return <input type={type} className={cn(BASE, className)} {...props} />;
  }

  // Password fields get an eye button to show/hide what's been typed.
  return (
    <div className="relative w-full">
      <input type={visible ? "text" : "password"} className={cn(BASE, "pr-11", className)} {...props} />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Hide password" : "Show password"}
        aria-pressed={visible}
        className="absolute inset-y-0 right-0 flex w-11 items-center justify-center rounded-r-xl text-muted-foreground hover:text-slate-900 focus:outline-none focus-visible:text-primary"
      >
        {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
}
